import { forwardRef, ReactElement } from 'react'
import RestoreFromTrash from '@mui/icons-material/RestoreFromTrash'
import { IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface Props extends IconButtonProps {
  tooltip?: string
  enterDelay?: number
}

const RestoreFromTrashIconButton = forwardRef<HTMLButtonElement, Props>(
  (
    { tooltip = 'Wiederherstellen', enterDelay, size = 'small', color = 'success', ...props },
    ref,
  ): ReactElement => {
    const button = (
      <IconButton ref={ref} size={size} color={color} {...props}>
        <RestoreFromTrash />
      </IconButton>
    )

    if (!tooltip) {
      return button
    }

    return (
      <Tooltip title={tooltip} enterDelay={enterDelay}>
        {button}
      </Tooltip>
    )
  },
)

RestoreFromTrashIconButton.displayName = 'RestoreFromTrashIconButton'

export default RestoreFromTrashIconButton
